// Per-service SEO overrides — hand-tuned titles (~55-60 chars) and meta
// descriptions (~150-160 chars) optimized for local Vancouver intent.
// Fallback to SERVICE_DETAILS lead paragraph when a slug is missing here.

export const SERVICE_SEO = {
  "ev-charger-installation": {
    title: "EV Charger Installation Vancouver | Level 2 · CleanBC Rebate | ElectroMax",
    description:
      "Licensed Level 2 EV charger installation across Metro Vancouver. Panel checked, permit pulled, CleanBC + BC Hydro rebates handled. Free written estimate.",
  },
  "panel-upgrades": {
    title: "200-Amp Panel Upgrade Vancouver BC | Permit + Inspection | ElectroMax",
    description:
      "60A/100A to 200A panel upgrades in Metro Vancouver by BC-licensed electricians. Permit filed, BC Hydro coordinated, inspection closed the same day.",
  },
  "commercial-wiring": {
    title: "Commercial Electrical Contractor Vancouver | Tenant Improvements | ElectroMax",
    description:
      "Vancouver commercial electricians for tenant improvements, retail fit-outs, and service upgrades. Licensed, bonded, and WorkSafeBC covered. Free estimates.",
  },
  "general-electrical": {
    title: "Electrician Near Me | Licensed & Local in Surrey, BC",
    description:
      "Need a licensed electrician near you in Surrey? ElectroMax is local, available now, and answers the phone. Call for a free estimate.",
  },
  lighting: {
    title: "Lighting Design & Installation Vancouver BC | Recessed, LED, Landscape",
    description:
      "Design-and-install lighting for Vancouver homes and businesses — recessed, track, landscape, and architectural. Every fixture wired to BC Electrical Code.",
  },
  security: {
    title: "Security System & Home Automation Wiring Vancouver | ElectroMax",
    description:
      "Licensed electrician for hardwired CCTV, smart locks, and full home automation across Metro Vancouver. Panel checked first, cable pulled once, done properly.",
  },
  emergency: {
    title: "24/7 Emergency Electrician Vancouver BC | Same-Night Response | ElectroMax",
    description:
      "24-hour emergency electrician on call across the Lower Mainland. Sparking outlets, tripped panels, burning smells — dispatched within 45–60 min in Vancouver.",
  },
};
